import eia8602001coal from  "./mapData/eia8602001coal.json"
import eia8602002coal from  "./mapData/eia8602002coal.json"
import eia8602003coal from  "./mapData/eia8602003coal.json"
import eia8602004coal from  "./mapData/eia8602004coal.json"
import eia8602005coal from  "./mapData/eia8602005coal.json"
import eia8602006coal from  "./mapData/eia8602006coal.json"
import eia8602007coal from  "./mapData/eia8602007coal.json"
import eia8602008coal from  "./mapData/eia8602008coal.json"
import eia8602009coal from  "./mapData/eia8602009coal.json"
import eia8602010coal from  "./mapData/eia8602010coal.json"
import eia8602011coal from  "./mapData/eia8602011coal.json"
import eia8602012coal from  "./mapData/eia8602012coal.json"
import eia8602013coal from  "./mapData/eia8602013coal.json"
import eia8602014coal from  "./mapData/eia8602014coal.json"
import eia8602015coal from  "./mapData/eia8602015coal.json"
import eia8602016coal from  "./mapData/eia8602016coal.json"

import eia8602001gas from  "./mapData/eia8602001gas.json"
import eia8602002gas from  "./mapData/eia8602002gas.json"
import eia8602003gas from  "./mapData/eia8602003gas.json"
import eia8602004gas from  "./mapData/eia8602004gas.json"
import eia8602005gas from  "./mapData/eia8602005gas.json"
import eia8602006gas from  "./mapData/eia8602006gas.json"
import eia8602007gas from  "./mapData/eia8602007gas.json"
import eia8602008gas from  "./mapData/eia8602008gas.json"
import eia8602009gas from  "./mapData/eia8602009gas.json"
import eia8602010gas from  "./mapData/eia8602010gas.json"
import eia8602011gas from  "./mapData/eia8602011gas.json"
import eia8602012gas from  "./mapData/eia8602012gas.json"
import eia8602013gas from  "./mapData/eia8602013gas.json"
import eia8602014gas from  "./mapData/eia8602014gas.json"
import eia8602015gas from  "./mapData/eia8602015gas.json"
import eia8602016gas from  "./mapData/eia8602016gas.json"


import React, { Component } from "react"
import {
    ComposableMap,
    ZoomableGroup,
    Geographies,
    Geography,
    Markers,
    Marker,
} from "react-simple-maps"

import { scaleLinear } from "d3-scale"

const MIN_OUTPUT = 400;

const wrapperStyles = {
    width: "100%",
    maxWidth: 980,
    margin: "50 auto",
    fontFamily: "Roboto, sans-serif",
};

//const wrapperStyles = {
//  width: "100%",
//  maxWidth: 980,
//  margin: "0 auto",
//}

//const utilityScale = scaleLinear()
//  .domain([0,37843000])
//  .range([1,25])

const yearDataCoal= {
    A2001: eia8602001coal,
    A2002: eia8602002coal,
    A2003: eia8602003coal,
    A2004: eia8602004coal,
    A2005: eia8602005coal,
    A2006: eia8602006coal,
    A2007: eia8602007coal,
    A2008: eia8602008coal,
    A2009: eia8602009coal,
    A2010: eia8602010coal,
    A2011: eia8602011coal,
    A2012: eia8602012coal,
    A2013: eia8602013coal,
    A2014: eia8602014coal,
    A2015: eia8602015coal,
    A2016: eia8602016coal
};

const yearDataGas = {
    A2001: eia8602001gas,
    A2002: eia8602002gas,
    A2003: eia8602003gas,
    A2004: eia8602004gas,
    A2005: eia8602005gas,
    A2006: eia8602006gas,
    A2007: eia8602007gas,
    A2008: eia8602008gas,
    A2009: eia8602009gas,
    A2010: eia8602010gas,
    A2011: eia8602011gas,
    A2012: eia8602012gas,
    A2013: eia8602013gas,
    A2014: eia8602014gas,
    A2015: eia8602015gas,
    A2016: eia8602016gas
};

const color = {
    CLETPUS: "black", //Coal
    PAETPUS: "#19586D", //Petroleum
    NGETPUS: "#ffcc00", //Natural Gas
    OJETPUS: "#D3D3D3", //Other Gases
    NUETPUS: "81FF14", //Nuclear
    HPETPUS: "blue", //Hydroelectric Pumped Storage
    HVETPUS: "blue", //Conventional Hydroelectric Power
    WDETPUS: "brown", //Wood
    WSETPUS: "#847e08", //Waste
    GEETPUS: "#ee3b3b", //Geothermal
    SOETPUS: "#ffd900", //Solar
    WYETPUS: "#ADD8E6", //Wind
};

class BasicMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            //utility: [],
            utilityCoal: [],
            utilityGas: [],
        }
        this.fetchUtility = this.fetchUtility.bind(this)
    }

    componentDidMount() {
        //this.fetchUtility()
        setTimeout(this.fetchUtility, 1000);
    }

    fetchUtility() {
        let self = this;
        let year = "A" + self.props.year;
        // console.log("################# year", year);
        //
        // console.log("year data", yearData[year]);
        let yDataCoal = yearDataCoal[year];
        let yDataGas = yearDataGas[year];

        //mapBubbles[i]=addBubble(topojson.feature(geodata, geodata.objects.collection).features.filter(function(d){return d.properties[engList[i]]>engMin;}), engList[i]);

        //let filteredData = eia8602011.filter(d => d.Coal > 100 || d.Gas > 100);
        //let filteredDataCoal = yData.filter(d => d.Coal > 100);
        //let filteredDataGas = yData.filter(d =>  d.Gas > 100);
        self.setState({
            //utility: filteredData,
            utilityCoal: yDataCoal,
            utilityGas: yDataGas,
        })
    }

    componentWillReceiveProps() {
        console.log("received new props");
        this.fetchUtility();
    }

    render() {

//        const wrapperStyles = {
//            width: "100%",
//            maxWidth: 980,
//            margin: "0 auto",
//            display: (this.props.hidden ? 'none': 'block'),
//            height: 551
//        };

        return (
            <div className="ratio-container">
                <div style={wrapperStyles} className="ratio-container-content">
                    <div className="map-title">
                        <h2 >Power Plant Output Over Time</h2>
                    </div>
                    <img src="map-legend.png" className="legend-map"/>
                    <ComposableMap
                        projection="albersUsa"
                        projectionConfig={{
                            scale: 1000,
//                            scale: 400,
//                            rotation: [-11,0,0],
                        }}
                        width={980}
                        height={500}
                        style={{
                            width: "100%",
                            height: "auto",
                        }}
                    >
                        <ZoomableGroup center={[-100,40]} disablePanning>
                            <Geographies geography="us-states.json">
                                {(geographies, projection) => geographies.map((geography, i) => geography.id !== "ATA" && (
                                    <Geography
                                        key={i}
                                        geography={geography}
                                        projection={projection}
                                        style={{
                                            default: {
                                                fill: "#ECEFF1",
                                                stroke: "#607D8B",
                                                strokeWidth: 0.75,
                                                outline: "none",
                                            },
                                            hover: {
                                                fill: "#ECEFF1",
                                                stroke: "#607D8B",
                                                strokeWidth: 0.75,
                                                outline: "none",
                                            },
                                            pressed: {
                                                fill: "#ECEFF1",
                                                stroke: "#607D8B",
                                                strokeWidth: 0.75,
                                                outline: "none",
                                            }
                                        }}
                                    />
                                ))}
                            </Geographies>
                            <Markers>
                                {
                                    this.state.utilityCoal.map((utilityCoal, i) => (
                                        <Marker key={i} marker={utilityCoal}>
                                            <circle
                                                cx={0}
                                                cy={0}
                                                r={utilityCoal.Coal/200}//{utilityScale(utility.Gas)}
                                                fill={color.CLETPUS}
                                                opacity={0.5}
                                            />
                                        </Marker>
                                    ))
                                }
                            </Markers>
                            <Markers>
                                {
                                    this.state.utilityGas.map((utilityGas, i) => (
                                        <Marker key={i} marker={utilityGas}>
                                            <circle
                                                cx={0}
                                                cy={0}
                                                r={utilityGas.Gas/200}//{utilityScale(utility.Gas)}
                                                fill={color.NGETPUS}
                                                opacity={0.5}
                                            />
                                        </Marker>
                                    ))
                                }
                            </Markers>
                        </ZoomableGroup>
                    </ComposableMap>
                </div>
            </div>
        )
    }
}

export default BasicMap;



// WEBPACK FOOTER //
// ./src/USMapChart.jsx